import FormEntry from "@components/form/FormEntry";
import FormRow from "@components/form/FormRow";
import Input from "@components/form/Input";
import React from "react";
import useCigRegisterContext from "../context/useCigRegisterContext";
import Button from "@components/form/Button";
import { IoArrowForward } from "react-icons/io5";
import CigRegisterResendCodeBar from "../CigRegisterResendCodeBar";

export default function EmailConfirmStep() {
  const { values, validations, onChange, onBlur, inputSize, buttonSize, emailConfirmIsLoading } =
    useCigRegisterContext();

  return (
    <>
      <div className="break">
        <div className="form-box">
          <p className="text">
            We have sent a confirmation code to{" "}
            <a href={`mailto:${values.email}`}>{values.email}</a>.
          </p>
          <p className="text">Be sure to check your spam folder.</p>
        </div>
        <CigRegisterResendCodeBar
          type="confirmation"
          email={values.email}
          disabled={emailConfirmIsLoading}
        />
      </div>

      <FormRow className="email-confirm-code-form-row">
        <FormEntry label="CONFIRMATION CODE" validation={validations.emailConfirmCode}>
          <Input
            color="black-2"
            textColor="white"
            size={inputSize}
            name="emailConfirmCode"
            placeholder="******"
            type="number"
            value={values.emailConfirmCode}
            onChange={onChange}
            onBlur={onBlur}
            disabled={emailConfirmIsLoading}
          />
        </FormEntry>
      </FormRow>

      <div className="button-row">
        <Button
          color="gray-1"
          textColor="white"
          size={buttonSize}
          type="submit"
          to="/"
          disabled={emailConfirmIsLoading}>
          Cancel
        </Button>
        <Button
          color="purple"
          textColor="white"
          size={buttonSize}
          type="submit"
          justifyContent="center"
          endIcon={<IoArrowForward />}
          isLoading={emailConfirmIsLoading}>
          Confirm
        </Button>
      </div>
    </>
  );
}
